<template>
  <div id="Organisation">
    <div class="container">
      <header class="header">
        <div class="header-left">
          <h2>Provisioning</h2>
        </div>
        <div class="header-right">
          <form class="header-form">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                aria-describedby="searchCust"
                placeholder="Search"
                v-model="searchCust"
                v-debounce:400ms="searchCustomer"
              />
              <em class="icon-search"></em>
            </div>
          </form>
          <a
            @click="$modal.show('createProvision',{customer_id : '' , tab: 'address'})"
            class="btn header-btn primary"
          >Add New Section</a>
        </div>
        <p v-if="totalCustomers > 1 && !searchCust">You have {{totalCustomers}} sections in the system.</p>
        <p v-else-if="totalCustomers <= 1 && !searchCust">You have {{totalCustomers}} section in the system.</p>
        <p v-else-if="totalCustomers > 1 && searchCust">You have {{totalCustomers}} sections in the search result.</p>
        <p v-else>You have {{totalCustomers}} sections in the search result.</p>
      </header>
      <div class="data-content" v-if="coursesLists.length !== 0">
        <div class="data-table data-column-5">
          <div class="data-head provision-data-head">
            <div class="data-col">
              Section
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.name' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.name','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.name' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.name','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col text-center">
              Total Learners
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.user_sections_count' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.user_sections_count','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.user_sections_count' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.user_sections_count','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col  text-center">
              Learner Done
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.elm_completed_count' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.elm_completed_count','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.elm_completed_count' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.elm_completed_count','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col  text-center">
              Instructors
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.section_instructors_count' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.section_instructors_count','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.section_instructors_count' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.section_instructors_count','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col  text-center">
              Start Date
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.start_date' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.start_date','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.start_date' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.start_date','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
           <div class="data-col  text-center">
              End Date
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'sections.end_date' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('sections.end_date','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'sections.end_date' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('sections.end_date','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col  text-center">
              Customer
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'customers.name' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('customers.name','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'customers.name' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('customers.name','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col  text-center">
              Course
              <span class="data-sort">
                <a
                  class="asc"
                  :class="[sortColumn === 'customer_courses.name' && sortOrder === 'asc' ? 'active' : '']"
                  @click="toggleSort('customer_courses.name','asc')"
                >
                  <em class="icon-carrot-up"></em>
                </a>
                <a
                  class="desc"
                  :class="[sortColumn === 'customer_courses.name' && sortOrder === 'desc' ? 'active' : '']"
                  @click="toggleSort('customer_courses.name','desc')"
                >
                  <em class="icon-carrot-down"></em>
                </a>
              </span>
            </div>
            <div class="data-col">ACTIONS</div>
          </div>
          <div class="data-items">
            <div class="data-row provision-data-row" v-for="course in coursesLists" :key="course.id">

              <div class="data-col"><a @click="$modal.show('createProvision',{customer_id : course.id, tab: 'address' })">{{course.attributes.name}} [ID: {{course.id}}]</a></div>
              <div class="data-col  text-center">{{course.attributes.user_sections_count}}</div>
              <div class="data-col  text-center">{{course.attributes.elm_completed_count}}</div>
              <div class="data-col  text-center">{{course.attributes.section_instructors_count}}</div>
              <div class="data-col  text-center" v-if="course.attributes.start_date == false">-</div>
              <div class="data-col  text-center" v-if="course.attributes.end_date == false">-</div>

              <div class="data-col  text-center" v-if="course.attributes.start_date != false">{{course.attributes.start_date}}</div>
              <div class="data-col  text-center" v-if="course.attributes.end_date != false">{{course.attributes.end_date}}</div>
              <div class="data-col  text-center">{{course.attributes.customer_name}}</div>
              <div class="data-col text-center">{{course.attributes.course_name}}</div>

              <div class="data-col data-action">
                <div class="data-dropdown">
                <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle">
                <em class="icon-menu"></em></button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul>
                      <li><a @click="$modal.show('createProvision',{customer_id : course.id, tab: 'address' })">Edit</a></li>
                      <li><a class="dropdown-error" @click="deleteProvision(course.id)">Delete</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data-footer">
          <div class="data-results">Showing {{page}} of {{totalPages.length}}</div>
          <div aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" v-if="page !== 1">
                <a class="page-link" aria-label="Previous" @click="prevPage">
                  <em class="icon-prev"></em>
                </a>
              </li>
              <li class="page-item" v-for="pages in totalPages.slice(page-1, page+3)" :key="pages">
                <a
                  class="page-link"
                  :class="[pages === page ? 'active' : '']"
                  @click="getProvisions(pages)"
                >{{pages}}</a>
              </li>
              <li class="page-item" v-if="page < totalPages.length">
                <a class="page-link" aria-label="Next" @click="nextPage">
                  <em class="icon-next"></em>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="data-no-result" v-if="coursesLists.length === 0 && !searchCust && display">
        <h3>There’s nothing here!</h3>
        <p>You have no customer in the system yet.</p>
        <div>
          <a
            @click="$modal.show('createProvision',{customer_id : '' })"
            class="btn header-btn primary"
          >Add a new customer</a>
        </div>
      </div>
      <div class="data-no-result" v-if="coursesLists.length === 0 && searchCust">
        <h3>No results found</h3>
        <p>Try using a different keyword</p>
      </div>
    </div>
    <createProvision />
  </div>
</template>

<script>
import { commonConfig } from "@/utils/commonConfig";
import { utilFunctionService } from "@/utils/utils.service";
import api from "../services/api";
import createProvision from "../components/modal/provision.vue";

export default {
  name: "Provision-component",
  components: {
    createProvision
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: false
      },
      searchRole: "",
      roles: [],
      page: 1,
      coursesLists: [],
      totalCustomers: "",
      totalPages: [],
      searchCust: "",
      sortOrder: "desc",
      sortColumn: "name",
      isActive: false,
      url: utilFunctionService.getImageUrl(),
      display : false
    };
  },
  methods: {
    show() {
      this.$modal.show();
    },
    hide(modal) {
      this.$modal.hide(modal);
      this.getProvisions(this.page);
    },
    searchCustomer(value) {
      this.display = false;
      api
        .getProvisions(
          commonConfig.setting.searchPage,
          value,
          this.sortColumn,
          this.sortOrder
        )
        .then(res => {
          this.coursesLists = res.data.data;
          this.totalCustomers = res.data.filtered_count;
          this.totalPages = [];
          for (let ind = 1; ind <= res.data.total_pages; ind++) {
            this.totalPages.push(ind);
          }
        })
        .catch();
    },
    getProvisions(page) {
      utilFunctionService.showLoader();
      this.page = page;
      api
        .getProvisions(
          page,
          this.searchCust,
          this.sortColumn,
          this.sortOrder
        )
        .then(res => {
          this.display = true;
          utilFunctionService.hideLoader();
          this.coursesLists = res.data.data;
          this.totalCustomers = res.data.filtered_count;
          this.totalPages = [];
          for (let ind = 1; ind <= res.data.total_pages; ind++) {
            this.totalPages.push(ind);
          }
        })
        .catch(() => {
          utilFunctionService.hideLoader();
        });
    },
    toggleSort(colName, sortType) {
      this.sortOrder = sortType;
      this.sortColumn = colName;
      this.getProvisions(this.page);
    },
    deleteProvision(id) {
      utilFunctionService.showLoader();
      api.deleteProvision(id).then(() => {
        utilFunctionService.hideLoader();
        let page;
          if (this.coursesLists.length === 1) {
            page = this.page;
            if (page === 1) {
              page = 1;
              this.getProvisions(page);
            } else {
              page = this.page - 1;
              this.getProvisions(page);
            }
          } else {
            const page = this.page;
            this.getProvisions(page);
          }
        utilFunctionService.showSuccess(commonConfig.appMessages.deleteProvision);
      })
      .catch(error => {
          utilFunctionService.showErr(
            error.response.data.errors
          );
          utilFunctionService.hideLoader();
      });
    },
    nextPage() {
      this.page = this.page + 1;
      this.getProvisions(this.page);
    },
    prevPage() {
      this.page = this.page - 1;
      this.getProvisions(this.page);
    }
  },
  created() {
    this.getProvisions(this.page);
  }
};
</script>
